import { getMasterDataApi } from "../../components/pages/location/LocationRoute";
import { getStreetDataApi } from "../../components/pages/parking/SmartParkingRoute";
import {
  API_ACCOUNTS_ROLES,
  API_REGISTER_USER,
  API_SERVICE_RATES,
  API_SERVICE_TYPES,
  API_SURCHARGE_CONFIGURABLES,
  API_USERS,
  API_VEHICLE_CLAMPINGS,
} from "../../utils/apis";

export function submitUsers(payload: any, id: string) {
  const updatedPayload = () => {
    const payloadData = payload || {};

    // Handle groups - ensure it's an array but don't double-wrap
    if (payloadData?.groups && !Array.isArray(payloadData.groups)) {
      payloadData.groups = [payloadData.groups];
    }

    const {
      nationality,
      parking,
      service,
      tin,
      physical_address,
      street,
      district,
      ...restPayload
    } = payloadData;

    const profileData = {
      ...(nationality && { nationality }),
      // Convert parking to array if it exists and is not already an array
      ...(parking && {
        parking: Array.isArray(parking) ? parking : [parking],
      }),
      ...(service && {
        service: Array.isArray(service) ? service : [service],
      }),
      ...(tin && { tin }),
      ...(physical_address && { physical_address }),
      ...(street && { street }),

      district,

      ...payloadData.profile,
    };

    // Build final payload
    const finalPayload = {
      ...restPayload,
      profile: profileData,
    };

    return finalPayload;
  };

  // UPDATE
  if (id) {
    return {
      id,
      api: API_USERS,
      params: updatedPayload(),
    };
  }

  // CREATE
  return {
    api: API_REGISTER_USER,
    params: updatedPayload(),
  };
}

export function submitRoles(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_ACCOUNTS_ROLES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_ACCOUNTS_ROLES,
    params: {
      ...payload,
    },
  };
}

export function submitServiceRates(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_SERVICE_RATES,
      params: payload,
    };
  }
  return {
    api: API_SERVICE_RATES,
    params: payload,
  };
}

export function submitServiceTypes(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_SERVICE_TYPES,
      params: payload,
    };
  }
  return {
    api: API_SERVICE_TYPES,
    params: payload,
  };
}

export function submitSurchargeConfigurables(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_SURCHARGE_CONFIGURABLES,
      params: payload,
    };
  }
  return {
    api: API_SURCHARGE_CONFIGURABLES,
    params: payload,
  };
}

export function submitMasterData(payload: any, id: string) {
  //  on update
  if (id) {
    const location_type = window.location.pathname.split("/")[1];
    return {
      id,
      api: getMasterDataApi(location_type),
      params: {
        name: payload?.name,
        region: payload?.region,
        district: payload?.district,
        parent: payload?.parent,
        charge_mode: payload?.charge_mode,
        logo: payload?.logo,
        vote_code: payload?.vote_code,
      },
    };
  }
  // on create
  return {
    api: getMasterDataApi(payload?.location_type),
    params: payload,
  };
}

//MARK: - STREET PARKING CONFIGRURABLES
export function submitStreetsData(payload: any, id: string) {
  //  on update
  if (id) {
    const street_type = window.location.pathname.split("/")[1];
    const getUpdateParams = () => {
      switch (street_type) {
        case "streets":
          return {
            name: payload?.name,
            parent: payload?.parent,
          };

        case "parkings":
          return {
            name: payload?.name,
            street: payload?.street,
            capacity: payload?.capacity,
            longitude: payload?.longitude,
            latitude: payload?.latitude,
          };

        case "slots":
          return {
            name: payload?.name,
            parking: payload?.parking,
            slot_number: payload?.slot_number,
            is_available: payload?.is_available,
          };

        case "booking_rate":
          const transformedBookingPayload = {
            ...payload,
          };
          // If booking type is sticker or advance, remove type
          if (
            payload.booking_type === "sticker" ||
            payload.booking_type === "advance"
          ) {
            delete transformedBookingPayload.type;
          }
          return transformedBookingPayload;

        case "parking_rates":
          return {
            location_type: "district",
            ...payload,
          };
        case "parked_cars":
          return {
            name: payload?.name,
            slot: payload?.slot,
            car_plate: payload?.car_plate,
            parked_at: payload?.parked_at,
            duration: payload?.duration,
          };

        case "payment_modes":
          return {
            mode: payload?.mode,
            description: payload?.description,
            active: payload?.active,
            city: payload?.city,
          };

        case "telecom_codes":
          return {
            code: payload?.code,
            network: payload?.network,
          };
        case "system_accounts":
          return payload;

        case "liquidation_requests":
          return payload;

        case "billing_invoices":
          return payload;
        case "car_slot_mappings":
          return payload;

        // case "reconciliations":
        //   return payload;

        default:
          // Fallback - return all payload except street_type
          const { ...restPayload } = payload;
          return restPayload;
      }
    };

    return {
      id,
      api: getStreetDataApi(street_type),
      params: getUpdateParams(),
    };
  }

  // on create
  const street_type = window.location.pathname.split("/")[1];
  return {
    api: getStreetDataApi(street_type),
    params: payload,
  };
}

//MARK: - BOOKING CONFIGURABLES
export function submitBookingsData(payload: any, id: string) {
  // Transform the payload
  const transformedPayload = {
    ...payload,
  };

  // If booking type is sticker or advance, remove number_of_slots
  if (
    payload.booking_type === "sticker" ||
    payload.booking_type === "advance"
  ) {
    delete transformedPayload.number_of_slots;
  }

  // Rename 'type' to 'bk_type' if it exists
  if ("type" in transformedPayload) {
    transformedPayload.bk_type = transformedPayload.type;
    delete transformedPayload.type;
  }

  if (payload.reserved_parkings) {
    if (Array.isArray(payload.reserved_parkings)) {
      // Take the first element from the array
      transformedPayload.reserved_parking = payload.reserved_parkings[0];
    } else if (typeof payload.reserved_parkings === "string") {
      // If it's already a string, use it directly
      transformedPayload.reserved_parking = payload.reserved_parkings;
    }

    // Remove the original reserved_parkings field
    delete transformedPayload.reserved_parkings;
  }

  // on update
  if (id) {
    return {
      id,
      api: "bookings/",
      //getBookingsDataApi(booking_data_type),
      params: transformedPayload,
    };
  }

  // on create
  return {
    api: "bookings/",
    //getBookingsDataApi(payload?.booking_data_type),
    params: transformedPayload,
  };
}

export function submitVehicleClamping(payload: any, id: string) {
  // on update
  if (id) {
    return {
      id,
      api: API_VEHICLE_CLAMPINGS,
      params: payload,
    };
  }

  // on create
  return {
    api: API_VEHICLE_CLAMPINGS,
    params: payload,
  };
}
